<template>
  <div>
    <headerCustom></headerCustom>
    <div class="template main-content sidenav-part ng-scope">
      <!-- <div id="progressBar">
    <div class="loader"></div>
      </div>-->
      <div>
        <div class="heading-sec">
          <div class="row">
            <div class="col-md-4 column">
              <div class="heading-profile">
                <h3>User</h3>
              </div>
            </div>
          </div>
        </div>
        <!-- Top Bar Chart -->
        <div class="panel-content">
          <div class="row">
            <div class="col-md-12">
              <div class="widget">
                <div class="table-area">
                  <div class="widget-title">
                    <div class="float-right">
                      <form class="search-form mr-form">
                        <input
                          type="text "
                          class="form-control"
                          v-model="searchText"
                          @input="viewUserList(1)"
                          placeholder="Search Here..."
                        />
                      </form>
                      <!-- create router link -->
                      <!-- <router-link to="CreateUser" class="btn btn-success
                      btn-small">Create</router-link> -->
                    </div>
                    <div class="d-flex">
                      <div>
                        <h3>
                          List of User
                          <span class="tableTotal">(Total : {{ totalCount }})</span>
                        </h3>
                      </div>
                      <div class=" ml-3 ">
                        <b-button variant="success" @click="generateExcelForUser(page)"
                          >Download</b-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table text-nowrap">
                      <thead>
                        <tr>
                          <th>Sr.No.</th>
                          <th>Date of Sign</th>

                          <th>Name</th>

                          <th>Email</th>

                          <th>Phone</th>
                          <!-- <th>Access Level</th> -->
                          <th>City</th>
                          <th>State</th>
                          <th>Country</th>
                          <th>Last Login Date &amp; Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(user, index) in users" v-bind:key="user._id">
                          <td>{{ index + 1 + (page - 1) * 10 }}</td>
                          <td>
                            <div v-if="user.createdAt">
                              {{ user.createdAt | moment("DD/MM/YYYY") }}
                            </div>
                            <div v-else>
                              {{ user.userCreatedAt | moment("DD/MM/YYYY") }}
                            </div>
                          </td>

                          <td>
                            <div>{{ user.name }}</div>
                          </td>

                          <td>
                            <div>{{ user.email }}</div>
                          </td>

                          <td>
                            <div>{{ user.phone }}</div>
                          </td>
                          <!-- <td>
                            <div>{{ user.accessLevel }}</div>
                          </td> -->
                          <td>
                            <div>{{ user.city }}</div>
                          </td>
                          <td>
                            <div>{{ user.state }}</div>
                          </td>
                          <td>
                            <div>{{ user.country }}</div>
                          </td>
                          <td>
                            {{
                              user.loginData && user.loginData.length > 0
                                ? moment(
                                    user.loginData[user.loginData.length - 1].lastLogin
                                  ).format("DD/MM/YYYY hh:mm A")
                                : ""
                            }}
                          </td>
                          <td>
                            <router-link
                              class="btn btn-primary"
                              :to="'/viewUserDetail/' + user._id"
                              append
                            >
                              <b-icon-eye></b-icon-eye>
                            </router-link>
                          </td>
                          <!-- v-repeat -->
                          <!-- <td>
                            <div class="d-flex">
                              <div class="mr-2">
                                <router-link class="btn btn-primary" to="/editUser" append>
                                  <b-icon-pencil></b-icon-pencil>
                                </router-link>
                              </div>
                              <div>
                                <deletemodal v-bind:mymodal="user"></deletemodal>
                              </div>
                            </div>
                          </td> -->
                        </tr>
                        <!-- end v-repeat -->
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-body-contents text-center m-3 font-size-md
                    font-weight-bold text-muted"
                    v-if="users.length === 0"
                  >
                    No Data Found
                  </div>
                  <div class="text-center" v-if="users.length >= 1">
                    <b-pagination
                      class="mb-0 float-right"
                      v-model="page"
                      align="center"
                      :total-rows="totalCount"
                      :per-page="formData.limit"
                      @input="viewUserList(page)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerCustom from "@/components/Header.vue";
import apiservice from "@/service/apiservice";
import moment from "moment";

export default {
  components: {
    headerCustom
  },
  data() {
    return {
      id: "",
      logs: {
        idToDelete: ""
      },
      currentPage: 1,
      searchText: "",
      users: [],
      page: 1,
      formData: { limit: 10 },
      totalCount: 0,
      perPage: 10,
      errors: [],
      data: "",
      email: "",
      moment: moment
    };
  },
  methods: {
    viewUserList(pageNo) {
      this.users = [];
      this.formData.page = pageNo;
      this.formData.limit = this.perPage;
      this.formData.search = this.searchText;
      apiservice.viewUserList(this.formData, data => {
        if (data.code === 200) {
          this.users = data.data.result;
          this.totalCount = data.data.count;
        } else {
        }
      });
    },
    generateExcelForUser() {
      apiservice.generateExcelForUser({}, data => {
        apiservice.downloadExcel(data, "User_List");
      });
    }
  },
  created() {
    this.viewUserList(this.page);
  }
};
</script>

<style></style>
